import { FETCH_USERS, FETCH_USER } from "../types";

const initialState = {
  loading: false,
  message: null,
  data: {},
};

export const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_USERS}_PENDING`:
      return { ...state, loading: true };

    case `${FETCH_USERS}_FULFILLED`:
      const { data, pagination } = action.payload.data?.results || {};
      return {
        ...state,
        loading: false,
        data: {
          results: data,
        },
        pagination,
        message:
          action.payload.data?.message ||
          "Failed getting users,reload and try again",
      };

    case `${FETCH_USERS}_REJECTED`:
      return {
        ...state,
        loading: false,
        message: action.payload.data.message,
      };

    default:
      return state;
  }
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${FETCH_USER}_PENDING`:
      return { ...state, loading: true };

    case `${FETCH_USER}_FULFILLED`:
      const result = action.payload.data.results
        ? action.payload.data.results
        : {};
      return {
        ...state,
        loading: false,
        data: result,
        message: action.payload.data.message,
      };

    case `${FETCH_USER}_REJECTED`:
      return {
        ...state,
        loading: false,
        message: action.payload.data.message,
      };

    default:
      return state;
  }
};
